// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1cZ8w","ul":"ul-50KDP","icon":"icon-1Ird9","button":"button-2aQ_r","page":"page-3ECZe","selected":"selected-28apb"};